import SiteLayout from "@/components/feature/SiteLayout";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryQuickLinks from "@/pages/home/components/CategoryQuickLinks";
import PopularGrid from "@/pages/home/components/PopularGrid";
import FeaturedCollections from "@/pages/home/components/FeaturedCollections";
import SiteIntro from "@/pages/home/components/SiteIntro";

export default function Home() {
  return (
    <SiteLayout>
      <div className="w-full">
        <h1 className="sr-only">韩漫大全无删减免费阅读下拉 - 热门韩漫在线浏览平台</h1>
        <HeroCarousel />
        <CategoryQuickLinks />
        <PopularGrid />
        <FeaturedCollections />
        <SiteIntro />
      </div>
    </SiteLayout>
  );
}